import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AdviserBridgePermissionCheck } from '../../Models/Models/Customer/AdviserBridgePermissionCheck';

declare var IS_RUNNING_IN_APP_POOL;

export class AdviserBridgePermissionCheckClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(actorId: number): Promise<AdviserBridgePermissionCheck, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/AdviserBridgePermissionCheck/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { actorId: actorId }

    return AjaxWrapper.get<AdviserBridgePermissionCheck, any>(url, data);
  }
}

